// extracted by mini-css-extract-plugin
module.exports = {"container":"ProxyCheckmark_container__OTiP7","checkMark":"ProxyCheckmark_checkMark__3W0Li"};